import React, { useState, useRef } from 'react';
import JoditEditor from 'jodit-react';
import classNames from 'classnames';

function cleanGoogleDocsLists(html) {
   const parser = new DOMParser();
   const doc = parser.parseFromString(html, 'text/html');

   // limpiar <ul> y <ol>
   doc.querySelectorAll('ul, ol').forEach((list) => {
      list.removeAttribute('style');
      list.removeAttribute('id');
      list.removeAttribute('dir');
      list.removeAttribute('aria-level');
   });

   // limpiar <li>
   doc.querySelectorAll('li').forEach((li) => {
      li.removeAttribute('style');
      li.removeAttribute('id');
      li.removeAttribute('dir');
      li.removeAttribute('aria-level');

      // Reemplazar <p> por su contenido
      li.querySelectorAll('p').forEach((p) => {
         const fragment = document.createDocumentFragment();
         while (p.firstChild) fragment.appendChild(p.firstChild);
         p.replaceWith(fragment);
      });

      // Reemplazar <span> por contenido manteniendo negrita/cursiva
      li.querySelectorAll('span').forEach((span) => {
         const style = span.style;
         let wrapper = null;

         // Detectar negrita
         if ((style.fontWeight && parseInt(style.fontWeight) >= 600) || span.tagName === 'STRONG') {
            wrapper = document.createElement('strong');
         }

         // Detectar cursiva
         if (style.fontStyle === 'italic' || span.tagName === 'EM') {
            const em = document.createElement('em');
            if (wrapper) {
               em.appendChild(wrapper);
               wrapper = em;
            } else {
               wrapper = em;
            }
         }

         if (wrapper) {
            while (span.firstChild) wrapper.appendChild(span.firstChild);
            span.replaceWith(wrapper);
         } else {
            // No hay estilos especiales, solo reemplazar el span
            const fragment = document.createDocumentFragment();
            while (span.firstChild) fragment.appendChild(span.firstChild);
            span.replaceWith(fragment);
         }
      });
   });

   // limpiar font-family
   doc.querySelectorAll('[style*="font-family"]').forEach((el) => {
      el.style.fontFamily = 'inherit';
   });

   return doc.body.innerHTML;
}

export const Editor = ({ className, input, editor, meta: { touched, error } }) => {
   // const editor = useRef(null);

   const config = {
      readonly: false,
      uploader: {
         insertImageAsBase64URI: true,
      },
      askBeforePasteHTML: false,
      askBeforePasteFromWord: true,
      askBeforePasteHTML: true,
      defaultActionOnPaste: 'insert_as_html',
      processPasteFromWord: {
         removeStyles: true, // Removes inline styles but keeps semantic HTML
         removeHeaders: false, // KEEP headers (h1-h6)
         removeEmpty: true, // Remove empty paragraphs
         keepOnlyTags: [
            'p',
            'br', // Paragraphs and breaks
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6', // All headers
            'ul',
            'ol',
            'li', // Lists
            'b',
            'strong',
            'i',
            'em',
            'u',
            's', // Text formatting
            'a', // Links
            'blockquote', // Quotes
            'table',
            'tr',
            'td',
            'th',
            'thead',
            'tbody', // Tables
            'li',
            'ul',
            'ol', // lists
         ],
      },
      processPasteHTML: {
         removeStyles: true, // Removes inline styles but keeps semantic HTML
         removeHeaders: false, // KEEP headers (h1-h6)
         removeEmpty: true, // Remove empty paragraphs
         keepOnlyTags: [
            'p',
            'br', // Paragraphs and breaks
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6', // All headers
            'ul',
            'ol',
            'li', // Lists
            'b',
            'strong',
            'i',
            'em',
            'u',
            's', // Text formatting
            'a', // Links
            'blockquote', // Quotes
            'table',
            'tr',
            'td',
            'th',
            'thead',
            'tbody', // Tables
            'li',
            'ul',
            'ol', // lists
         ],
      },
      disablePlugins: 'addnewline',
      buttons:
         'bold,strikethrough,underline,italic,eraser,|,|,ul,ol,|,fontsize,brush,paragraph,,image,file,table,link,|,align,|,hr,fullsize',
      events: {
         // event to format the input value when pasting
         afterPaste: function () {
            const valueToFormat = input.value;
            const cleaned = cleanGoogleDocsLists(valueToFormat);

            input.onChange(cleaned);
         },
      },
   };
   const invalid = touched && error;
   return (
      <div className={classNames({ 'is-invalid': invalid })}>
         <JoditEditor
            ref={editor}
            value={input.value}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onBlur={(newContent) => {
               const cleaned = cleanGoogleDocsLists(newContent);
               input.onChange(cleaned);
            }}
         />
         {invalid && <div className="invalid-feedback">{error}</div>}
      </div>
   );
};
